import React from 'react'
import cx from 'classnames'
import { Box } from 'components/layout/Box/Box'
import { Checkbox } from 'components/shared/FormFields/common/Checkbox/Checkbox'
import { Table } from 'components/shared/Table/Table'

import type { TableCellProps } from 'components/shared/Table/types'
import styles from './CheckboxCell.module.scss'

type CheckboxCellProps = Pick<
  TableCellProps,
  'className' | 'type' | 'hasIncreasedHeight'
> & {
  onChange?: React.ChangeEventHandler<HTMLInputElement>
  isChecked?: boolean
  isIndeterminate?: boolean
  isDisabled?: boolean
}

export const CheckboxCell = ({
  type,
  onChange,
  hasIncreasedHeight,
  isChecked,
  isIndeterminate,
  isDisabled,
  className,
}: CheckboxCellProps) => {
  const ref = React.useRef<HTMLInputElement>(null)

  return (
    <Table.Cell
      className={cx(styles.cell, className)}
      {...{ type, hasIncreasedHeight }}
    >
      <Box align="center" justify="center" tagName="span">
        <Checkbox
          value={isChecked}
          {...{ ref, onChange, isIndeterminate, isDisabled }}
        />
      </Box>
    </Table.Cell>
  )
}
